import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LanguageSwitcher from '../components/LanguageSwitcher';

const Apply = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLanguage = i18n.language;

  // Redirect to correct localized URL based on language
  useEffect(() => {
    const correctPath = currentLanguage === 'fr' ? '/demandez' : '/apply';
    if (location.pathname !== correctPath) {
      navigate(correctPath, { replace: true });
    }
  }, [currentLanguage, location.pathname, navigate]);

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle iframe message for form completion redirect
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data.step === 'LEADGENFORMCOMPLETED' && e.data.success) {
        window.location.href = e.data.redirectTo;
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="min-h-screen bg-[#0D47A1]">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0D47A1] border-b border-[#00E676]/20 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo + Brand */}
            <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <img
                src="/flexisolutions-5.png"
                alt="Flex Solution Logo"
                className="w-[97px] h-[97px] drop-shadow-lg"
              />
              <span className="text-3xl font-bold text-white whitespace-nowrap">{t('header.brandName')}</span>
            </Link>

            {/* Back Link + Language Switcher */}
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="flex items-center gap-2 text-gray-200 hover:text-[#FFD600] font-medium transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
                <span className="hidden sm:inline">{t('apply.backToHome')}</span>
              </Link>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>

      {/* Page Title */}
      <section className="py-8 bg-[#0a3b80]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">{t('apply.title')}</h1>
          <p className="text-gray-200">{t('apply.subtitle')}</p>
        </div>
      </section>

      {/* Iframe Container */}
      <section className="py-8 bg-[#0D47A1]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <iframe
            src={`https://app.flexsolution.ca/api/v1/get-lead-iframe?${currentLanguage === 'fr' ? 'lang=fr&' : ''}lead_source=flex_solution`}
            style={{ position: 'relative', width: '1px', minWidth: '100%' }}
            frameBorder="0"
            scrolling="yes"
            seamless="seamless"
            height={currentLanguage === 'fr' ? '800' : '1500'}
            width="100%"
            title="Loan Application Form"
          />
        </div>
      </section>
    </div>
  );
};

export default Apply;
